import { useState } from 'react';

export default function Projects() {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Read App Design',
      category: 'mobile',
      description: 'Mobile reading application design with intuitive user interface and seamless reading experience',
      image: 'https://public.readdy.ai/ai/img_res/e75b8262e1b7484865ce3e6110718e99.jpg',
      tags: ['UI Design', 'Mobile', 'Figma'],
      link: 'https://ochre-decaf-36122197.figma.site'
    },
    {
      id: 2,
      title: 'Tennis Game App',
      category: 'mobile',
      description: 'Interactive tennis game application design featuring engaging gameplay mechanics and modern sports interface',
      image: 'https://readdy.ai/api/search-image?query=Modern%20tennis%20game%20mobile%20app%20interface%20design%20mockup%20on%20smartphone%2C%20sports%20gaming%20UI%20with%20tennis%20court%20elements%2C%20vibrant%20athletic%20design%2C%20clean%20mobile%20game%20layout%2C%20professional%20product%20photography%2C%20simple%20white%20background%2C%20high%20quality%20design%20showcase&width=800&height=600&seq=project-tennis-game&orientation=landscape',
      tags: ['UI Design', 'Mobile', 'Figma'],
      link: 'https://fax-kale-92458283.figma.site'
    },
    {
      id: 3,
      title: 'Math Tennis',
      category: 'web',
      description: 'Serve up your math skills. Every correct answer wins a point in a real tennis match. Master multiplication, volume, and division — one question, one rally at a time.',
      image: 'https://static.readdy.ai/image/f77f6aa78adb73f9994f91e3447ad68f/8812e513b162b86ece29ab1c03c7557a.png',
      tags: ['Web', 'Development'],
      link: 'https://math-tennis.readdy.co'
    }
  ];

  const filters = [
    { id: 'all', label: 'All Projects' },
    { id: 'web', label: 'Web Development' },
    { id: 'mobile', label: 'Mobile Apps' },
    { id: 'design', label: 'Design' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-teal-50 text-teal-600 rounded-full text-sm font-semibold">
              Portfolio
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Featured Projects
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
            A selection of my recent work showcasing creativity, technical skills, and attention to detail
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            {filters.map(filter => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeFilter === filter.id
                    ? 'bg-gradient-to-r from-teal-500 to-blue-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map(project => (
            <div 
              key={project.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4 flex gap-3">
                    <a 
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 px-4 py-2 bg-white text-gray-900 rounded-lg font-semibold text-center hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      View Project
                    </a>
                    <a 
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 flex items-center justify-center bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
                    >
                      <i className="ri-external-link-line text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
              
              <a 
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="p-6 block hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{project.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-teal-50 text-teal-600 rounded-full text-sm font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
